import * as React from 'react';
import { identity } from 'lodash';
import { connect } from 'react-redux';

import { AppState } from 'src/store';
import { wrappedDispatch, WrappedDispatch } from 'src/utils/Redux/Dispatch';
import {
  AddBreadcrumbPayload,
  addCrumb,
  CrumbPath,
  removeCrumbsAfterId,
  resetAllCrumbs,
  clearActiveRestore,
} from 'src/state/breadcrumbs/Bread.slice';
import { removeLastCrumb, resetCrumbsByKey } from 'src/state/breadcrumbs/Bread.slice';

export interface InjectedProps<ParentProps> {
  parentProps: ParentProps;
  addCrumb(payload: AddBreadcrumbPayload): void;
  removeCrumbsAfterId(path: CrumbPath): void;
  removeLastCrumb(): void;
  resetAllCrumbs(): void;
  resetCrumbsByKey(key: string): void;
  clearActiveRestore(): void;
}

export interface WithBreadCrumbProps
  extends Pick<
    InjectedProps<unknown>,
    | 'addCrumb'
    | 'removeCrumbsAfterId'
    | 'removeLastCrumb'
    | 'resetAllCrumbs'
    | 'resetCrumbsByKey'
    | 'clearActiveRestore'
  > {}

export interface Nameable {
  displayName?: string;
  name?: string;
}

function mergeProps<P>(_state: AppState, wrapped: WrappedDispatch, parentProps: P): InjectedProps<P> {
  return {
    parentProps,
    addCrumb: (payload) => wrapped.dispatch(addCrumb(payload)),
    removeCrumbsAfterId: (path) => wrapped.dispatch(removeCrumbsAfterId(path)),
    removeLastCrumb: () => wrapped.dispatch(removeLastCrumb()),
    resetAllCrumbs: () => wrapped.dispatch(resetAllCrumbs()),
    resetCrumbsByKey: (key) => wrapped.dispatch(resetCrumbsByKey(key)),
    clearActiveRestore: () => wrapped.dispatch(clearActiveRestore()),
  };
}

export function makeBreadcrumbSensitive<P>(WrappedComponent: React.ComponentType<P>) {
  class BreadcrumbSensitive extends React.Component<InjectedProps<P>> {
    displayName = 'BreadcrumbSensitive';
    constructor(props: InjectedProps<P>) {
      super(props);
    }

    render() {
      return (
        <WrappedComponent
          addCrumb={this.props.addCrumb}
          removeCrumbsAfterId={this.props.removeCrumbsAfterId}
          removeLastCrumb={this.props.removeLastCrumb}
          resetCrumbsByKey={this.props.resetCrumbsByKey}
          resetAllCrumbs={this.props.resetAllCrumbs}
          clearActiveRestore={this.props.clearActiveRestore}
          {...this.props.parentProps}
        />
      );
    }
  }

  return connect<AppState, WrappedDispatch, P, InjectedProps<P>>(
    identity,
    wrappedDispatch,
    mergeProps,
  )(BreadcrumbSensitive);
}
